// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2xulv","col":"styles_col__2fGSO","fulfillmentStatus":"styles_fulfillmentStatus__1aD17","emailCol":"styles_emailCol__1IKSX"};